import { render, staticRenderFns } from "./batchUpload.vue?vue&type=template&id=58a21ee8&scoped=true"
import script from "./batchUpload.vue?vue&type=script&lang=js"
export * from "./batchUpload.vue?vue&type=script&lang=js"
import style0 from "./batchUpload.vue?vue&type=style&index=0&id=58a21ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a21ee8",
  null
  
)

export default component.exports